<template>
  <div class="d-flex flex-column fv-row" :class="[containerClass]">
    <label class="d-flex align-items-center fs-6 form-label mb-2">
      <span :class="required ? 'required' : ''">{{ label }}</span>
    </label>
    <div class="input-group input-group-solid mb-5">
      <span class="input-group-text">
        <div
            class="rating-label me-2"
            @click="checkRating(rate)"
            v-for="(rate, i) in filterRating"
            :key="i"
            :title="getTooltip(rate)"
            :class="isChecked(rate) ? 'checked' : ''">
            <i class="fa fa-star fs-2"></i>
        </div>
      </span>
    </div>
  </div>
</template>

<script setup>
import {defineProps, ref, onMounted, watch, computed} from "vue";
import {useLocales} from "@/composables/locales";

const {locale} = useLocales()
const model = defineModel()

const props = defineProps({
  label: String,
  containerClass: {
    type: String,
    default: 'col-12 mt-2 mb-5'
  },
  priorities:{type: Array, default: []},
  description: String,
})


const selected = computed(() => {
  return props.priorities.filter(el => el.value == model.value)[0]
})

const filterRating = computed(() => {
  return props.priorities.filter(el => el.value != 0)
})

function checkRating(n) {
  if(model.value == n.value && n.value == 1){
    model.value = 0
  }else{
    model.value = n.value
  }
}

function getTooltip(rate){
  return rate[locale?.value]
}

onMounted(() => {

})
const isChecked = (n) => {
  return n.value <= model.value
}
</script>

<style scoped>
.btn_class{
  border-radius: '8px';
}
</style>